export default {
    props: {
        transportDiscover: {
            type: [Object, String, Function],
            default: undefined,
            kComposite: 'transport.discover'
        }, 
        transportConnectionCatalog: {
            type: String,
            default: undefined,
            kComposite: 'transport.connection.catalog'
        }, 
        transportConnectionCube: {
            type: String,
            default: undefined,
            kComposite: 'transport.connection.cube'
        },
        transportCreate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'transport.create'
        }, 
        transportCreateCache: {
            type: Boolean,
            default: undefined,
            kComposite: 'transport.create.cache'
        }, 
        transportCreateContentType: {
            type: String,
            default: undefined,
            kComposite: 'transport.create.contentType'
        }, 
        transportCreateData: {
            type: [Object, Function],
            default: undefined,
            kComposite: 'transport.create.data'
        }, 
        transportCreateDataType: {
            type: String,
            default: undefined,
            kComposite: 'transport.create.dataType'
        }, 
        transportCreateType: {
            type: String,
            default: undefined,
            kComposite: 'transport.create.type'
        }, 
        transportCreateUrl: {
            type: [String, Function],
            default: undefined,
            kComposite: 'transport.create.url'
        }, 
        transportDestroy: {
            type: [String, Function],
            default: undefined,
            kComposite: 'transport.destroy'
        }, 
        transportDestroyCache: {
            type: Boolean,
            default: undefined,
            kComposite: 'transport.destroy.cache'
        }, 
        transportDestroyContentType: {
            type: String,
            default: undefined,
            kComposite: 'transport.destroy.contentType'
        }, 
        transportDestroyData: {
            type: [Object, Function],
            default: undefined,
            kComposite: 'transport.destroy.data'
        }, 
        transportDestroyDataType: {
            type: String,
            default: undefined,
            kComposite: 'transport.destroy.dataType'
        }, 
        transportDestroyType: {
            type: String,
            default: undefined,
            kComposite: 'transport.destroy.type'
        }, 
        transportDestroyUrl: {
            type: [String, Function],
            default: undefined,
            kComposite: 'transport.destroy.url'
        }, 
        transportParameterMap: {
            type: Function,
            default: undefined,
            kComposite: 'transport.parameterMap'
        }, 
        transportPush: {
            type: Function,
            default: undefined,
            kComposite: 'transport.push'
        }, 
        transportRead: {
            type: [String, Function],
            default: undefined,
            kComposite: 'transport.read'
        }, 
        transportReadCache: {
            type: Boolean,
            default: undefined,
            kComposite: 'transport.read.cache'
        }, 
        transportReadContentType: {
            type: String,
            default: undefined,
            kComposite: 'transport.read.contentType'
        }, 
        transportReadData: {
            type: [Object, Function],
            default: undefined,
            kComposite: 'transport.read.data'
        }, 
        transportReadDataType: {
            type: String,
            default: undefined,
            kComposite: 'transport.read.dataType'
        }, 
        transportReadType: {
            type: String,
            default: undefined,
            kComposite: 'transport.read.type'
        }, 
        transportReadUrl: {
            type: [String, Function],
            default: undefined,
            kComposite: 'transport.read.url'
        }, 
        transportSignalrClientCreate: {
            type: String,
            default: undefined,
            kComposite: 'transport.signalr.client.create'
        }, 
        transportSignalrClientDestroy: {
            type: String,
            default: undefined,
            kComposite: 'transport.signalr.client.destroy'
        }, 
        transportSignalrClientRead: {
            type: String,
            default: undefined,
            kComposite: 'transport.signalr.client.read'
        }, 
        transportSignalrClientUpdate: {
            type: String,
            default: undefined,
            kComposite: 'transport.signalr.client.update'
        }, 
        transportSignalrHub: {
            type: Object,
            default: undefined,
            kComposite: 'transport.signalr.hub'
        }, 
        transportSignalrPromise: {
            type: Object,
            default: undefined,
            kComposite: 'transport.signalr.promise'
        }, 
        transportSignalrServerCreate: {
            type: String,
            default: undefined,
            kComposite: 'transport.signalr.server.create'
        }, 
        transportSignalrServerDestroy: {
            type: String,
            default: undefined,
            kComposite: 'transport.signalr.server.destroy'
        }, 
        transportSignalrServerRead: {
            type: String,
            default: undefined,
            kComposite: 'transport.signalr.server.read'
        }, 
        transportSignalrServerUpdate: {
            type: String,
            default: undefined,
            kComposite: 'transport.signalr.server.update'
        }, 
        transportSubmit: {
            type: Function,
            default: undefined,
            kComposite: 'transport.submit'
        }, 
        transportUpdate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'transport.update'
        }, 
        transportUpdateCache: {
            type: Boolean,
            default: undefined,
            kComposite: 'transport.update.cache'
        }, 
        transportUpdateContentType: {
            type: String,
            default: undefined,
            kComposite: 'transport.update.contentType'
        }, 
        transportUpdateData: {
            type: [Object, Function],
            default: undefined,
            kComposite: 'transport.update.data'
        }, 
        transportUpdateDataType: {
            type: String,
            default: undefined,
            kComposite: 'transport.update.dataType'
        }, 
        transportUpdateType: {
            type: String,
            default: undefined,
            kComposite: 'transport.update.type'
        }, 
        transportUpdateUrl: {
            type: [String, Function],
            default: undefined,
            kComposite: 'transport.update.url'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoPivotDataSource/Transport.js